import { lazy } from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = lazy(() => import('modules/performance_feedbacks/pages/RootPage'))

const GiveFeedback = lazy(() => import('modules/performance_feedbacks/pages/GiveFeedback'))
const GivenFeedback = lazy(() => import('modules/performance_feedbacks/pages/GivenFeedback'))
const PendingRequests = lazy(() => import('modules/performance_feedbacks/pages/PendingRequests'))
const ReceivedFeedback = lazy(() => import('modules/performance_feedbacks/pages/ReceivedFeedback'))

export const performanceFeedbacksRoutes: NavigationRoutesFn = (navigation) => {
  return [
    {
      path: navigation.performanceFeedbacks.path.replace(
        `${navigation.performanceProcess.path}/`,
        ''
      ),
      element: <RootPage />,
      handle: {
        meta: () => {
          return {
            title: i18n.t('performance_feedbacks.pages.feedbacks_index.title'),
            description: i18n.t('performance_feedbacks.pages.feedbacks_index.description'),
            illustration: 'performance_management',
            subNavigation: [
              {
                index: true,
                title: i18n.t('performance_feedbacks.tabs.received'),
                href: navigation.performanceFeedbacks.fullPath(),
              },
              {
                title: i18n.t('performance_feedbacks.tabs.given'),
                href: navigation.performanceFeedbacks.given.fullPath(),
              },
              {
                title: i18n.t('performance_feedbacks.tabs.pending_requests'),
                href: navigation.performanceFeedbacks.pendingRequests.fullPath(),
                isVisible: false, // TODO: hiding the tab until we have 'request feedback' functionality implemented
              },
            ],
          }
        },
      },
      // Feedback Tabs
      children: [
        {
          index: true,
          element: <ReceivedFeedback />,
        },
        {
          path: navigation.performanceFeedbacks.giveFeedback.path,
          element: <GiveFeedback />,
        },
        {
          path: navigation.performanceFeedbacks.given.path,
          element: <GivenFeedback />,
        },
        {
          path: navigation.performanceFeedbacks.pendingRequests.path,
          element: <PendingRequests />,
        },
      ],
    },
  ]
}
